import { z } from 'zod';

export enum CheckInHistoryActionEnum {
  CHECK_IN = 'check-in',
  CHECK_OUT = 'check-out',
}

export const CheckInHistorySchema = z.object({
  id: z.string(),
  action: z.nativeEnum(CheckInHistoryActionEnum),
  scanned: z.boolean(),
  effectiveAt: z.union([z.string().datetime(), z.date().transform((effectiveAt) => effectiveAt.toISOString())]),
  author: z.object({
    fullName: z.string(),
  }),
});
